// @flow
import { decorate, observable, action } from 'mobx';
import Api from '../../api';

class ContentStore {
  content: Object = {};
  isFetchingContent: boolean = true;

  async fetchContent(type: string) {
    this.isFetchingContent = true;
    const { data } = await Api.getContent(type);
    this.content[type] = data;
    this.isFetchingContent = false;
  }
}

decorate(ContentStore, {
  isFetchingContent: observable,
  content: observable,
  fetchContent: action
});

export default new ContentStore();



// WEBPACK FOOTER //
// ./src/modules/content/ContentStore.js